module.exports = __webpack_public_path__ + "static/media/icon_arrow_back.cd1efe16.svg";